import React, { useCallback } from 'react'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';


const workflowBKFinalStep = () => {
  const style         = SideStyle();
  const activeStep    = Param.Get("activeStep");
  const setParam      = Param.Get("setParam");

  const onClick = useCallback((step) => {
    setParam(s => {s.activeStep = step});
  })
  
  function getActive(step){
    return (activeStep == step) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }
  function getDisabled(step){
    return false;
  }

  // onclick bindling way is not proper, we would need to change function to class and use bind function.
  return(
    <div>
      <Box className={style.moduleTitle}>WorkFlow</Box>
      <div className={style.workflow}>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={12}>
                <Button className={getActive(0)} onClick={() => onClick(0)} disabled={getDisabled(0)}>Alignment and Hole</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={6}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(1)} onClick={() => onClick(1)} disabled={getDisabled(1)}>Make hole</Button>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
}
export default workflowBKFinalStep;
